/**************************************************
 * Nombre:       Formulario_Producto_Especificaciones_Ingreso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {ChecklistOutlined, PlaylistAddCheckOutlined} from "@mui/icons-material";

const Formulario_Producto_Especificaciones_Ingreso = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoTexto Icono={ChecklistOutlined} nombre={'Nombre'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={PlaylistAddCheckOutlined} nombre={'Cantidad, medida o descripcion'}
                                  dato={'descripcion'} {...props}
                                  requerido={'El descripcion es requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Especificaciones_Ingreso